export enum PaymentStatus {
  NEW = 0,
  ACCEPTED = 1,
  CLOSED = 4,
  NOT_ACCEPTED = -1,
  WAITING = -2,
  TIMEOUT = -3,
  CANCELLED = -4
}
